import VentureScreen from '@/modules/home/components/VentureScreen';

// Mock data for different ventures
const ventureData = {
    'bloom-properties': {
        ventureName: 'Bloom Properties',
        ventureLogo: 'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg',
        ventureDescription: 'As one of the UAE\'s foremost development companies, Bloom Properties creates sought-after communities across the Emirates. Signature developments like Bloom Living, Bloom Gardens, Aldhay, Faya complex, Bloom Towers, Bloom Heights, Park View, Soho Square, Bloom Marina and Bloom Central. stand as a testament to Bloom\'s commitment to quality and innovation. Each community features top-class amenities designed to enhance lifestyle while offering compelling investment opportunities. From architectural excellence to curated spaces, Bloom delivers not just homes, but thriving communities that combine elevated living with attractive returns.',
        ventureImage: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
        hotels: [
            {
                id: 'bloom-living',
                name: 'Bloom Living, Abu Dhabi',
                image: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
            },
            {
                id: 'park-view',
                name: 'Park View',
                image: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
            },
        ],
    },
    'bloom-hospitality': {
        ventureName: 'Bloom Hospitality',
        ventureLogo: 'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg',
        ventureDescription: 'Bloom Hospitality is a leading hospitality company in the UAE, offering world-class accommodation and dining experiences. Our portfolio includes luxury hotels, resorts, and restaurants that showcase the best of Middle Eastern hospitality combined with international standards.',
        ventureImage: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
        hotels: [],
    },
    'bloom-education': {
        ventureName: 'Bloom Education',
        ventureLogo: 'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg',
        ventureDescription: 'Bloom Education is one of the region\'s leading education providers for more than a decade. We are committed to delivering exceptional educational experiences that prepare students for success in an ever-changing world.',
        ventureImage: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
        hotels: [],
    },
    'facility-management': {
        ventureName: 'Facility Management',
        ventureLogo: 'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg',
        ventureDescription: 'Our facility management services ensure that all Bloom properties maintain the highest standards of operation, maintenance, and customer service. We provide comprehensive facility management solutions that enhance property value and resident satisfaction.',
        ventureImage: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
        hotels: [],
    },
    'landscape': {
        ventureName: 'Landscape',
        ventureLogo: 'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg',
        ventureDescription: 'Bloom Landscape specializes in creating beautiful, sustainable outdoor environments that enhance the living experience. Our landscape design and maintenance services bring nature\'s beauty to urban spaces.',
        ventureImage: 'https://cdn.prod.website-files.com/65b8ae9b3af43cf735dab067/65d880f793077068d3cd5d67_%D0%BEb7acd61adc86d523ef07648e11f27f3a.webp',
        hotels: [],
    },
};

export default function VentureRoute() {
    // Get the venture ID from the route params
    const ventureId = 'bloom-properties'; // This would come from route params in a real implementation

    const venture = ventureData[ventureId as keyof typeof ventureData];

    if (!venture) {
        return null; // Handle error case
    }

    return <VentureScreen {...venture} />;
}
